import { connect } from 'react-redux';
import Upload from './Upload';
import { getImporter } from '../../../../../store/importer/selectors';
import { importFromFile } from '../../../../../store/importer/actions';

const mapStateToProps = (state) => ({
  importer: getImporter(state),
});

const mapDispatchToProps = (dispatch) => ({

  importFromFile: (file, destination) => {
    dispatch(importFromFile(file, destination));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Upload);
